import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'glamorous';
import { Redirect } from 'react-router-dom';
import Fetch from '../../../../common/components/Fetch';
import { TitleBar } from '../../../../common/components/Layout/StandardPageTemplate/Context';
import LoadingView from '../../../../common/components/LoadingView';
import withCustomerOrg from '../../../../common/components/withCustomerOrg';
import composes from '../../../../common/utils/composes';
import LoadingOverlay from '../../../../common/components/LoadingOverlay';
import StandardPageTemplate from '../../../../common/components/Layout/StandardPageTemplate';
import { withLoading } from '../../../../redux-modules/loading-overlay';
import withQuery from '../../../../common/components/withQuery';
import { WizardEngine, RenderActive } from '../Wizard';
import objectToArray from '../../../../common/utils/object-to-array';
import ProgressIndicator from '../ProgressIndicator';
import FederationProgress from './FederationProgress';
import OnboardingAuth from './OnboardingAuth';
import OnboardingComponents from './Steps';

const isLocationStepActive = (location, step) =>
  new RegExp(`${step.url}(.*)?`).test(location);

const RedirectActiveIndex = ({ steps, activeIndex, location }) => {
  const actualLocation = (location || {}).pathname;
  const currentStep = steps[activeIndex];

  if (currentStep && !isLocationStepActive(actualLocation, currentStep)) {
    return (
      <Redirect
        push
        to={`${currentStep.url}${(location || {}).search}`}
      />
    );
  }

  return null;
};

const PageTitleBar = ({ currentStep: { title, subtitle , component} }) => {
  title = component == "MemberBenefits" ? "NFIB Member Offers – Products and Services" : title;
  return <TitleBar title={component == "Completed" ? "Done" : title} subtitle={subtitle} />;
};

class OnboardingWizard extends React.Component {
  static propTypes = {
    location: PropTypes.object,
    currentUser: PropTypes.object,
    currentCustomer: PropTypes.object,
  };
  static promises = {
    includePromises: [
      {
        meta: { namespace: 'customers' },
      },
      {
        meta: { namespace: 'organizations' },
      },
    ],
  };

  getActiveIndex = ({ steps }) => {
    const actualLocation = this.props.location.pathname;
    const newIndex = objectToArray(steps).findIndex(step =>
      isLocationStepActive(actualLocation, step)
    );

    if (newIndex >= 0) {
      return newIndex;
    }

    return 0;
  };

  colorResolver = color => {
    return {
      name: color,
      value: this.props.theme.colors[color] || color,
    };
  };

  render() {
    const { currentUser, currentCustomer, location } = this.props;

    const commonProps = {
      currentUser,
      currentCustomer,
      currentOrganization: (currentCustomer || {}).organization,
      location,
    };

    return (
      <StandardPageTemplate
        defaultDocTitle="Member Federation | NFIB"
        showMenu
      >
          <Fetch url="/api/config/pages/onboarding">
            {({ data, pending }) => {
              return pending ? (
                <div>
                  <LoadingView />
                  <LoadingOverlay isLoading={pending} />
                </div>
              ) : (            
                <WizardEngine //#9531 Remove Member Offers Screen from eFed Process
                  steps={objectToArray(data.items).filter(itm=>{ return itm.key != "member-benefits"}).map(step => ({
                    ...step,
                    pageColor: this.colorResolver(step.color),
                  }))}
                  initActiveIndex={this.getActiveIndex}
                >               
                  <PageTitleBar />
                  <OnboardingAuth {...commonProps} />
                  <ProgressIndicator
                    showLabels={false}
                    style={{ marginBottom: '2rem' }}
                  />
                  <RenderActive
                    stepComponents={OnboardingComponents}
                    {...commonProps}
                  />
                  <FederationProgress />
                  <RedirectActiveIndex location={location} />
                </WizardEngine>
              );
            }}
          </Fetch>
        </StandardPageTemplate>
    );
  }
}

export default composes(
  OnboardingWizard,
  withLoading,
  withTheme,
  withCustomerOrg,
  withQuery
);



// WEBPACK FOOTER //
// ./src/App/account/components/Onboarding/index.js